<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Canteen Transaction Report</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
       <v-row justify="center" dense>
        <v-col cols="12" sm="3">
            <p><b>From Date</b></p>
            <v-text-field outlined dense type="date" v-model="fromdate"></v-text-field>
        </v-col>
         <v-col cols="12" sm="3">
                <p><b>To Date</b></p>
                <v-text-field outlined dense type="date" v-model="todate"></v-text-field>
          </v-col>
        <v-col cols="12" sm="2" class="pt-4" v-if="fromdate && todate">
            <br />
            <v-btn color="primary" @click="getCanteenReceiptsReport()">Fetch</v-btn>
        </v-col>
            </v-row>
       </v-card>
<!-- {{canteen_receipts_data}} -->

      <v-card class="box" v-if="canteen_receipts_data!=''">
         
          <div id="my-table-id">
     <v-data-table  :headers="headers" dense class="elevation-1 mytable" :items="canteen_receipts_data" :search="search" :items-per-page="-1">
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Canteen Transactions List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
                <b style="font-size: larger;"> Total <v-icon color="white" >mdi-currency-inr</v-icon><u>{{total_order_amount}}</u></b>
            </v-toolbar>
             <v-row dense>
          <v-col cols="12" sm="6" md="6">
            <v-btn rounded color="success" outlined @click="ExportToExcel()"
              ><v-icon color="success">mdi-export</v-icon>Export</v-btn
            >
          </v-col>

          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        </template>
        <template v-slot:[`item.total`]="{ item }">
        <v-chip>
          {{ item.total }}
        </v-chip>
      </template>
          <!-- <v-row justify="center" dense>
                <v-col cols="12" sm="9">
                </v-col>
                <v-col cols="12" sm="3">
                    <p><b>Total In Rs. : </b> {{total_order_amount}}</p>
                </v-col>
          </v-row> -->
         </v-data-table>
          </div>
         
       
 </v-card> 
        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      search:"",
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      // fromdate: new Date().toISOString().slice(0, 10),
      fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
      // fromdate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      // todate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString().substr(0, 10),
      todate: new Date().toISOString().slice(0, 10),
      headers:[
        { text: "SR No", value: "count" },
        { text: "Menu", value: "name" },
        { text: "Rate", value: "rate" },
        { text: "Quantity", value: "quantity" },
        { text: "Total", value: "total" },
      ],
      canteen_receipts_data:[],total_order_amount:0,
  }),
   methods: {
      getOrderDetailsTotal(){
       // alert("getOrderDetailsTotal")
        this.total_order_amount=0
            for (var i = 0; i < this.canteen_receipts_data.length; i++) {
                this.total_order_amount+=this.canteen_receipts_data[i].total
            }
            return this.total_order_amount
            },
     ExportToExcel() {
      this.exs_loader = true;
      var htmltable = document.getElementById("my-table-id");
      var html = htmltable.outerHTML;
      window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
      this.exs_loader = false;
    },
    getCanteenReceiptsReport(){
         this.canteen_receipts_data=[]
         const data = {
        fromdate: this.fromdate,
        todate: this.todate,
      };
      this.overlay = true;
      axios
        .post("/Canteen/getWalletDailyTransactionReport",data)
        .then((res) => {
          this.overlay = false;
          if (res.data.flag == "YES") {
             this.canteen_receipts_data = res.data.canteen_order_list;
          }  else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
          this.getOrderDetailsTotal();
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   // this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
.header-of-chart {
  font-weight: bold;
}
</style>